import React from "react";
import contactBg from "../Images/cantactbackground.jpg"; 
import "../ContactComponent/ContactComponentCss/ContactHeroSection.css";

export default function ContactHeroSection() {
  return (
    <section
      className="contact-hero-section"
      style={{ backgroundImage: `url(${contactBg})` }}
    >
      <div className="contact-hero-overlay"></div>

      <div className="contact-hero-content">
        <h1 className="contact-title">आमच्याशी संपर्क साधा</h1>

        <p className="contact-subtext">
          नागरिकांना आवश्यक अशा विविध शासकीय वेबसाईट्स आणि सेवांचा थेट दुव्यांचा
          संग्रह येथे उपलब्ध आहे. शासनाच्या योजना, अर्ज प्रक्रिया आणि माहिती
          सहजपणे मिळविण्यासाठी उपयुक्त विभाग.
        </p>
      </div>
    </section>
  );
}
